<template>
  <Avatar
    v-if="logo"
    :image="logo"
    :size="size"
    aria-hidden="true"
    class="client-logo"
    shape="circle"
  />
  <Avatar
    v-else
    :label="name?.substring(0, 1)"
    :size="size"
    :style="{ 'background-color': `#${accentColor}` }"
    aria-hidden="true"
    class="client-logo domain-avatar-no-logo"
    shape="circle"
  />
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { toRefs } from 'vue';

import { DomainBranding } from '@rygen/rygen-ui/model';

import Avatar from 'primevue/avatar';

const props = defineProps({
  accentColor: {
    type: String,
    default: () => DomainBranding.DEFAULT_ACCENT_COLOR,
  },
  name: {
    type: String,
    default: () => undefined,
  },
  logo: {
    type: String,
    default: () => undefined,
  },
  size: {
    type: String as PropType<'normal' | 'large' | 'xlarge'>,
    default: 'normal',
  },
});
const { accentColor, name, logo, size } = toRefs(props);
</script>

<style>
.client-logo.p-avatar {
  --p-avatar-color: white;
}
</style>
